<template>
  <v-form novalidate @submit.prevent="whenValid(onSubmit)">
    <v-layout v-if="$vuetify.breakpoint.xsOnly" column>
      <v-flex xs12 pb-0>
        <v-text-field
          ref="field"
          v-model.trim="form.search"
          box
          clearable
          :label="label"
          single-line
        ></v-text-field>
      </v-flex>
      <v-flex xs12 pt-0>
        <v-btn
          :disabled="errors.any() || !isComplete"
          color="primary"
          type="submit"
          large
          block
        >
          <v-icon>fas fa-search fa-sm</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout v-else>
      <v-flex xs10>
        <v-text-field
          ref="field"
          v-model.trim="form.search"
          clearable
          :label="label"
          single-line
        >
        </v-text-field>
      </v-flex>
      <v-flex sm2 pl-0>
        <v-btn
          :disabled="errors.any() || !isComplete"
          color="primary"
          type="submit"
          large
          flat
          class="mx-0 mb-0"
        >
          <v-icon dark>fas fa-search</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <v-alert
          v-if="searchError"
          :value="searchError"
          color="error"
          icon="fas fa-exclamation-triangle"
          outline
          class="mt-3"
        >
          {{ searchError }}
        </v-alert>
        <no-results v-else ref="nope"></no-results>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import validate from '../mixins/validate';
import { search } from '../api/search';
import NoResults from './NoResults';

export default {
  name: 'ShortSearchForm',
  components: { NoResults },
  mixins: [validate],
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    label: {
      type: String,
      default: 'Search for City, Address, Community, Zip Code',
    },
  },
  data() {
    return {
      form: {
        search: '',
      },
      error: null,
    };
  },
  computed: {
    ...mapGetters({ searchError: 'searchError' }),
    isComplete() {
      return this.form.search;
    },
  },
  mounted() {
    this.$validator.localize('en', this.dictionary);
  },
  methods: {
    ...mapMutations(['showSnackbar', 'closeSnackbar']),
    onSubmit() {
      this.$store.dispatch('search');
      search(this.$data.form)
        .then((res) => {
          this.$store.commit('searchSuccess', res);
          // this.clear()

          if (res.length) {
            this.searchSuccess();
            this.$router.push({ name: 'results' });
          } else {
            this.$refs.nope.dialog = true;
          }
        })
        .catch((error) => {
          this.$store.commit('searchFailed', { error });
          this.searchFailed();
        });
    },
    searchSuccess() {
      this.showSnackbar({
        text: 'Your search was successful!',
        color: 'success',
        timeout: 3000,
      });
    },
    searchFailed() {
      this.showSnackbar({
        text: 'There were problems with your search results!',
        color: 'warning',
        timeout: 3000,
      });
    },
    noResults() {},
    clear() {
      this.form.search = '';
      this.$validator.reset();
    },
  },
};
</script>
